var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2071 6.29289C20.5976 6.68342 20.5976 7.31658 20.2071 7.70711L10.2071 17.7071C9.81658 18.0976 9.18342 18.0976 8.79289 17.7071L4.29289 13.2071C3.90237 12.8166 3.90237 12.1834 4.29289 11.7929C4.68342 11.4024 5.31658 11.4024 5.70711 11.7929L9.5 15.5858L18.7929 6.29289C19.1834 5.90237 19.8166 5.90237 20.2071 6.29289Z",
    fill: "#00AB21"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/green_check.1bf9ed4247e996e9065adf57f219397f.svg";